// extracted by mini-css-extract-plugin
module.exports = {"travelIcon":"TravelIcon_travelIcon__X6j3v"};